<script lang="ts">
	import type { SbImage } from '../types';
	import Image from '../components/image.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import Circle from '$lib/icons/circle.svelte';
	import type { HTMLAttributes } from 'svelte/elements';
	import { editable } from '../editable';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';

	interface Props extends HTMLAttributes<HTMLLIElement> {
		content: ISbStoryData<{
			image: SbImage;
			text: string;
			subtext: ISbRichtext;
		}>['content'];
		variant: 'vertical' | 'horizontal' | 'leading-icon';
	}

	let { content, variant = 'vertical', class: className, ...other }: Props = $props();
</script>

<li
	use:editable={content}
	{...other}
	class={[
		'flex text-balance',
		className,
		{
			'h-full flex-col items-center text-center': variant === 'horizontal',
			'gap-1': variant === 'leading-icon',
			'gap-2': variant !== 'leading-icon'
		}
	]}
>
	{#if variant === 'leading-icon'}
		<Circle class="mt-[3px] h-4 w-4 text-brown-1" />
	{:else}
		<Image
			wrapperClass="aspect-square h-5 w-5 lg:h-6 lg:w-6 shrink-0 select-none"
			class="h-full w-full object-cover"
			src={content.image.filename}
			alt={content.image.alt}
			title={content.image.title}
			width={24}
			height={24}
		/>
	{/if}

	<div class={['flex h-full w-full flex-col', { 'justify-center': variant === 'horizontal' }]}>
		<p class={['text-[14px] text-brown-1', { 'leading-[normal]': variant === 'horizontal' }]}>
			{content.text}
		</p>

		{#if variant !== 'horizontal'}
			<div class="text-[12px]/[160%] text-brown-4 lg:text-[14px]/[160%]">
				<SbRichtext text={content.subtext} />
			</div>
		{/if}
	</div>
</li>
